import './navigation';
import './new-desktop-navigation';
import './new-mobile-navigation';
import { NewDefaultModules } from './components/newDefaultModules';
import './skip-link-focus-fix';
import './components/button-list';
import './components/tag-toggle'

const newDefaultModulesSelector = document.querySelector('.page-template-new-default-template')
const homeSelector = document.querySelector('.page-template-home-template')
const modulesSelector = document.querySelector('.page-template-module-template')

if (newDefaultModulesSelector) {
	new NewDefaultModules(newDefaultModulesSelector);
}
if (homeSelector) {
	new NewDefaultModules(homeSelector);
}
if (modulesSelector) {
	new NewDefaultModules(modulesSelector);
}

window.onload = function () {
  const searchFormEl = document.querySelector(".c-search-form_medium");

  if (searchFormEl) {
    const searchForm = searchFormEl.querySelector(".c-search-form__form");
    const searchInput = searchFormEl.querySelector(".c-search-form__input");
    const searchButton = searchFormEl.querySelector(".c-search-form__button");

    if (searchInput) {
      searchInput.addEventListener("focus", function (e) {
        this.classList.add("is-open");
      });
    }

    if (searchInput) {
      searchInput.addEventListener("blur", function (e) {
        if (!this.value) {
          searchInput.classList.remove("is-open");
        }
      });
    }

    // Only do search if there is a value in the search box
    if (searchButton) {
      searchButton.addEventListener("click", function (e) {
        // If user has typed something in search AND the bar isn't hidden then search
        if (searchInput.value) {
          searchForm.submit();
        } else {
          e.preventDefault();
          searchInput.focus();
        }
      });
    }
  }
};
